<template>
  <div id="category">
  	<BottomMenu></BottomMenu>
  	<mt-search placeholder="搜索" v-lfcous class="searchcatagory"></mt-search>
  	<div class="ulwrap">
  		<div class="left-menuwrap">
		  	<ul class="left-menu">
		  		<li v-for="(item,index) in firstClass" :data-index="index" :key="item.id" @click="onShowLevelClass(item.id)" :class="{active:currentId==item.id}">{{item.cateName}}</li>
		  	</ul>
	  	</div>
	  	<div class="right-content">
	  		<div class="right-main">
			  	<dl class="list-menu" v-for="item in LevelClass" :key="item.id" @click="categoryBuy(item.id,item.url,item.proType[0])">
						<dt><img :src="urlPrefixImg+'/'+item.proTImg"/></dt>
						<dd>{{item.cateName}}</dd>
					</dl>
				</div>
	  	</div>
  	</div>
  </div>
</template>

<script>
import BottomMenu from '@/components/BottomMenu'
export default {
  components: {
    BottomMenu,
  },
  data () {
    return {
      //tid: localStorage.getItem("tid"),//开始点击分类按钮时保存的标志
      cid:this.$route.query.gtids,   //点击首页分类按钮时用路由传过来的cid
      firstClass: [], //分类左侧数据
      LevelClass: [], //分类右侧数据
      currentId: "",
      urlPrefixImg: this.URL_PREFIX_IMG,
      totalPagesr:0,//右侧数据总页数
      listPage: 1, //右侧数据页数
      listFlag: true, //右侧开关
			uid:localStorage.getItem("firstId"),//点击时保存的商品id
    }
  },
  created: function () {
    this.showFirstClass();
    if(this.cid!=undefined){
    	this.uid=this.cid;
    	this.showLevelClass(this.cid);
    }else{
    	this.showLevelClass(localStorage.getItem("firstId"));
    }    
  },
  //搜索框自定义指令
  directives: {
    lfcous (el) {
      let oInput = el.querySelector('input');
      oInput.onfocus = function () {
        location.href = "/#/Search";
      };
    }
  },
  methods: {
    returnBack () {
      this.$router.go(-1);
    },
    //获取分类左侧数据
    showFirstClass () {
      this.$http.post(this.URL_PREFIX + "/category/findFirstCategoryApi.net", { page: 1, rows: 30 })
        .then((res) => {
            this.firstClass = res.data.rows;//分类左侧数据
//          console.log('分类左边数据');
//          console.log(res.data.rows);
//          console.log(this.cid+'cid');
            var id = res.data.rows[0].id;
            localStorage.setItem("firstId", id);           
        });
    },
    //左侧列表点击事件
    onShowLevelClass(uid){
	    document.querySelector('.right-main').style.transform='translate(0px, 0px) translateZ(0px)';
      this.listPage=1;
      this.listFlag = true;
      this.uid = uid;
      this.showLevelClass(uid);
    },
    //获取分类右侧数据
    showLevelClass(id){
      this.$http.post(this.URL_PREFIX + "/category/findCategoryTypeByType.net", { type: id, page: this.listPage, rows: 14 })
        .then((res) => {
	         this.totalPagesr=res.data.pageSize;
          if (this.listPage === 1) {
            this.LevelClass = res.data.rows; //分类右侧数据
            this.currentId = id;
          } else {
	          this.currentId = id;
            this.LevelClass=this.LevelClass.concat(res.data.rows);
            this.listFlag = true;            
          }
//          console.log('右侧数据');
//          console.log(res);
        });
    },
    //点击右则商品跳转
    categoryBuy (tids, urls, type) {
      localStorage.setItem("tid", tids);
      localStorage.removeItem("faceId");
      localStorage.removeItem("ttype");
      if (urls != "") {
	      localStorage.setItem("ttype",type);
        location.href = urls;
      } else if (type == 0) {
	      localStorage.setItem("ttype",type);
        this.$router.push({ path: "/Reallygood" });//实物
      } else {
	      localStorage.setItem("ttype",type);
        this.$router.push({ path: "/Cami" });
      }
    }
  },
  //分类页面滚动
  mounted(){
    let listHeight = 0;//右侧列表数据框高度
    let listHeightWapper = 0;//右侧列表外框高度
    //左边列表滚动
    let myscrollNav = new IScroll('.left-menuwrap', {
      probeType: 3,mouseWheel: true, click: true, tap: true
    })
    myscrollNav.on('scrollStart', () => {
      myscrollNav.refresh();
    });

    //右边列表滚动
    let myscrollList = new IScroll('.right-content', {
      probeType: 3,mouseWheel: true, click: true, tap: true
    })
    myscrollList.on('scrollStart', () => {
      listHeight = document.querySelector('.right-main').offsetHeight;
      listHeightWapper= document.querySelector('.right-content').offsetHeight;
      myscrollList.refresh();
    });
    myscrollList.on('scroll', () => {
      if (myscrollList.y <= -(listHeight-listHeightWapper)) {
        if (this.listFlag) {
          this.listFlag = false;
          this.listPage++;
					if(this.listPage>this.totalPagesr){
						return;
					}else {
			      this.showLevelClass(this.uid);
			    }
        }
      }
    })
  }
}
</script>

<style scoped="scoped">
#category{width:100%;height: 100%;position: absolute;left: 0;top:0;}
.left-menuwrap{width: 25%; overflow: hidden; background: #f3f3f3;}
.left-menu{text-align: center;background: #f3f3f3;}
.left-menu li{border-bottom: 1px solid #d6d6d6;border-right:1px solid #d6d6d6; height: 50px;line-height: 50px;font-size:0.9rem;color: #666;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.left-menu li.active{color: #ff8920;background-color: #fff;border-right: none;border-left:2px solid #ff8920;}
.list-menu{width: 30%;margin: 0 0 5% 15%;float: left;}
.list-menu dt img{width: 100%;}
.list-menu dt{width: 50px;margin: 0 auto;}
.list-menu dd{text-align: center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 0.8rem;margin: 5px auto;color: #333;}
.right-content{flex: 1;overflow:hidden;margin-top: 10px;}
.ulwrap{width: 100%;position: absolute;top: 52px;display: flex;bottom: 57px!important; overflow: hidden;}
.searchcatagory{position: fixed;width: 100%;}
.right-main{width: 100%;overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/views/Home/category.vue